import PropTypes from 'prop-types'

import './Alerts.scss'

import cn from '@/utilities/cn'

const SweetAlertSuccess = (props: any) => (
  <div className={cn('f-modal-alert flex-center', props.className)}>
    <div className="f-modal-icon f-modal-success animate group-[.is-dark]:before:bg-zinc-50 group-[.is-dark]:after:bg-zinc-50">
      <span className="f-modal-line f-modal-tip animateSuccessTip" />
      <span className="f-modal-line f-modal-long animateSuccessLong" />
      <div className="f-modal-placeholder" />
      <div className="f-modal-fix group-[.is-dark]:!bg-zinc-50" />
    </div>
    <div className="message">
      <span className="success-header">{props.message}</span>
      <p className="success-sub-header">{props.subMessage}</p>
    </div>
  </div>
)

SweetAlertSuccess.propTypes = {
  className: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

SweetAlertSuccess.defaultProps = {
  message: '',
  subMessage: '',
  className: ''
}

export default SweetAlertSuccess
